import {Injectable} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, retry} from 'rxjs/operators';
import {Router} from '@angular/router';
import {EnvironmentConfig} from '@environments/environment';
import {FirebaseAuthenticationService} from '@services/firebase/auth/firebase-authentication.service';
import {AuthenticationRedirectService} from '@services/user/authentication-redirect.service';

@Injectable()
export class GlobalErrorInterceptor implements HttpInterceptor {
  UNAUTHENTICATED_USER_REJECTION_STATUS = 401;
  FORBIDDEN_USER_REJECTION_STATUS = 403;

  constructor(
      private router: Router,
      private firebaseAuthenticationService: FirebaseAuthenticationService,
      private authenticationRedirectService: AuthenticationRedirectService,
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
        retry(1),
        catchError((error: HttpErrorResponse) => {
          let errorMessage: string;

          if (error.status === this.FORBIDDEN_USER_REJECTION_STATUS) {
            console.warn('Forbidden error. Error ' + this.FORBIDDEN_USER_REJECTION_STATUS, error);
            this.router.navigate(['dashboard']);
          } else if (error.status === this.UNAUTHENTICATED_USER_REJECTION_STATUS && this.shouldRedirectToLogin(request)) {
            const returnUrl = this.authenticationRedirectService.getReturnUrl() ?? this.router.url;
            this.firebaseAuthenticationService.clear();
            this.authenticationRedirectService.setReturnUrl(returnUrl);
            if (EnvironmentConfig.PortalSettings.ssoEnabled) {
              this.router.navigate(['samllogin']);
            } else {
              this.router.navigate(['login']);
            }
          }

          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
          } else {
            // server-side error
            errorMessage = `Error Status: ${error.status}\nMessage: ${error.message}`;
          }
          console.log(errorMessage, error);
          return throwError(() => error);
        })
    );
  }

  private shouldRedirectToLogin(request: HttpRequest<any>): boolean {
    if (this.isAuthenticationRequest(request.url)) {
      return false;
    }
    return !this.authenticationRedirectService.isAuthenticationRoute(this.router.url);
  }

  private isAuthenticationRequest(url: string): boolean {
    const path = url.split('?')[0].replace(/\/$/, '');
    return path.endsWith('/api/web/user/signIn')
      || path.endsWith('/api/web/user/saml/url')
      || path.endsWith('/api/web/user/saml/consume')
      || path.endsWith('/api/web/user/logout');
  }
}
